import React from 'react';
import cn from 'classnames';
import ReactPlayer from 'react-player/lazy';
import { isVideoUrl } from '../../utils/videoUrlValidation';

interface DaVideoPlayerProps {
  src: string;
  width?: number;
  height?: number;
  className?: string;
}

const DaVideoPlayer: React.FC<DaVideoPlayerProps> = ({ src, width, height, className }) => {
  if (!ReactPlayer.canPlay(src) || !isVideoUrl(src)) {
    return null;
  }
  return (
    <div
      data-canfs="yes"
      data-testid="video-inner"
      className={cn('main-video', className)}
      style={{ width, height }}
    >
      <ReactPlayer
        controls
        config={{ youtube: { playerVars: { fs: 1 } } }}
        url={src}
        width={width}
        height={height}
      />
    </div>
  );
};

export default DaVideoPlayer;
